import React from "react";
import Skeleton from "react-loading-skeleton";

function KpiCard({ kpi, loading, periodLabel, locale = "en" }) {
  if (loading) {
    return (
      <div className="col-md-6 col-lg-3">
        <div className="dash-stat-card dash-stat-card--specialists">
          <div className="dash-stat-card__icon">
            <Skeleton circle width={20} height={20} />
          </div>
          <div className="dash-stat-card__info">
            <h2><Skeleton width={60} height={24} /></h2>
            <small><Skeleton width={100} /></small>
          </div>
        </div>
      </div>
    );
  }

  const icon =
    kpi.change_direction === "up"
      ? "zmdi-trending-up"
      : kpi.change_direction === "down"
        ? "zmdi-trending-down"
        : "zmdi-trending-flat";

  const sign = kpi.change > 0 ? "+" : "";
  const numberFormatter = new Intl.NumberFormat(locale);
  const displayValue = typeof kpi.value === "number" ? numberFormatter.format(kpi.value) : kpi.value;
  const variant = kpi.variant || "specialists";
  const kpiIcon = kpi.icon || "zmdi-chart";

  return (
    <div className="col-md-6 col-lg-3">
      <div className={`dash-stat-card dash-stat-card--${variant}`}>
        <div className="dash-stat-card__icon">
          <i className={`zmdi ${kpiIcon}`} />
        </div>
        <div className="dash-stat-card__info">
          <div className="d-flex align-items-baseline">
            <h2>{displayValue}</h2>
            {kpi.change !== 0 && (
              <span className="dash-stat-card__change">
                <i className={`zmdi ${icon}`} /> {sign}{numberFormatter.format(kpi.change)} {periodLabel}
              </span>
            )}
          </div>
          <small>{kpi.label}</small>
        </div>
      </div>
    </div>
  );
}

function KpiCards({ kpis, loading, periodLabel, locale }) {
  if (loading) {
    return (
      <div className="row dash-stat-cards">
        {[1, 2, 3, 4].map((i) => (
          <KpiCard key={i} loading={true} locale={locale} />
        ))}
      </div>
    );
  }

  return (
    <div className="row dash-stat-cards">
      {(kpis || []).map((kpi) => (
        <KpiCard key={kpi.label} kpi={kpi} periodLabel={periodLabel} locale={locale} />
      ))}
    </div>
  );
}

export default KpiCards;
